import React from 'react'
import { Link } from "react-router-dom";
import { getUrlToPrivacyPolicyPage, getUrlToTermsAndConditionsPage } from "pages/urls";

export function SignupLoginAgreement () {
  return (
    <div className='text-gray-500 font-light'>
      By creating an account or logging in, you agree to Antidote's{" "}
      <Link to={getUrlToTermsAndConditionsPage()} target="_blank" className="underline">Terms and Conditions</Link> and{" "}
      <Link to={getUrlToPrivacyPolicyPage()} target="_blank" className="underline">Privacy Policy</Link>
    </div>
  )
}
